import submitsOnChanged from './submits-on-changed';
import productFilterGroups from './product-filter-groups';
import * as customFormContainer from './custom-form-container';
import * as episerverFormsAnchorFix from './episerver-forms-anchor-fix';

export function exec () {
    productFilterGroups();
    submitsOnChanged();
    customFormContainer.exec();
    episerverFormsAnchorFix.exec();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/forms/index.js